import React from "react";
import { statusClass } from "@/lib/statusStyles";

export default function StatusBadge({ status, testId }) {
  return (
    <span
      className={`status-badge ${statusClass(status)}`}
      data-testid={testId || "status-badge"}
    >
      {status}
    </span>
  );
}
